import { baseBackendUrl } from './baseService';

export interface AdminEpisode {
    id: string;
    name: string;
    description: string;
    poster: string;
    startsAt: string;
    stopsAt: string;
    isBlacklisted: boolean;
}

export const blacklistedEpisodeService = {
    getEpisodes: async (token: string): Promise<AdminEpisode[]> => {
        const response = await fetch(`${baseBackendUrl}/api/blacklisted-episodes/episodes`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Failed to fetch episodes');
        return response.json();
    },

    setBlacklisted: async (boxcastId: string, blacklisted: boolean, episodeName: string, token: string): Promise<void> => {
        const response = await fetch(`${baseBackendUrl}/api/blacklisted-episodes/${boxcastId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ blacklisted, episodeName })
        });
        if (!response.ok) throw new Error('Failed to update episode blacklist status');
    }
};
